export default "__VITE_ASSET__CoSMKudx__"